const $signIn = $('#sign-in');
const $signUp = $('#sign-up');
const $resetPassword = $('#reset-password');
const $signInEmail = $signIn.find('[type=email]');
const $signUpEmail = $signUp.find('[type=email]');
const $resetPasswordEmail = $resetPassword.find('[type=email]');
const $returnToAuthLogin = $('.return-to-auth-login');
const $linksOfTerms = $('#sign-up-links-terms');

function show($element) {
  $element
    .removeClass('fadeOutDown')
    .addClass('fadeInUp')
    .removeClass('hidden');

  $element
    .find('[type=email]')
    .trigger('focus')
    .trigger('select');
}

function hide($element) {
  if (!$element.hasClass('hidden')) {
    $element
      .removeClass('fadeInUp')
      .addClass('fadeOutDown')
      .addClass('hidden');
  }
  $element
    .find('[type=email]')
    .trigger('blur');
}

if ($signIn.length && $signUp.length) {
  $signInEmail.on('change', function () {
    $signUpEmail.val(this.value);
    $resetPasswordEmail.val(this.value);
  });

  $('[data-change]').on('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    const change = this.dataset.change;
    switch (change) {
      case '#sign-up':
        hide($signIn)
        hide($resetPassword)
        show($signUp)
        hide($linksOfTerms)
        break;
      case '#sign-in':
        hide($signUp)
        hide($resetPassword)
        show($signIn)
        show($linksOfTerms)
        break;
      case '#reset-password':
        hide($signUp)
        hide($signIn)
        show($resetPassword)
        break;
    }
  });
}

if ($returnToAuthLogin.length) {
  $returnToAuthLogin.on('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    window.location.href = $(this).data('authHost') + 'login';
  })
}
